var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentRatingOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_122)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81034 -0.258621C10.4311 -0.258621 19.0517 -0.258621 27.6724 -0.258621C28.3422 0.252604 29.0319 0.769846 29.7414 1.2931C29.7414 10.2586 29.7414 19.2242 29.7414 28.1897C29.0517 28.5345 28.5345 29.0517 28.1897 29.7414C19.2242 29.7414 10.2586 29.7414 1.2931 29.7414C0.948274 29.0517 0.431034 28.5345 -0.258621 28.1897C-0.258621 19.3966 -0.258621 10.6034 -0.258621 1.81034C0.25862 0.948274 0.948274 0.25862 1.81034 -0.258621Z",
    fill: "#6FB858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.46552C12.0226 6.42031 13.2295 8.4031 11.1207 12.4138C5.87265 12.8647 4.66575 10.8819 7.5 6.46552Z",
    fill: "#F9FCF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8793 6.46552C23.434 6.44689 24.6409 8.42969 22.5 12.4138C17.2837 12.8071 16.0768 10.8244 18.8793 6.46552Z",
    fill: "#F9FCF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39655 15.7759C10.9868 19.6996 17.7109 19.8721 24.569 16.2931C24.7102 18.0021 24.0206 19.4676 22.5 20.6897C17.0282 23.9255 11.6833 23.7531 6.46552 20.1724C5.28502 18.9324 4.59537 17.4669 4.39655 15.7759Z",
    fill: "#F8FBF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentRatingOk);
export default __webpack_public_path__ + "static/media/ic_content_rating_ok.0dcf33e641330302c5e6dc5213d40437.svg";
export { ForwardRef as ReactComponent };